import { businessAdvantages } from '../../constants/businessData';

// Business Advantage Card Component
function BusinessAdvantageCard({ number, title, description, image }: { 
  number: string; 
  title: string; 
  description: string; 
  image: string; 
}) {
  return (
    <div className="bg-[#ffffff] border border-[#eaeaea] box-border content-stretch flex flex-col items-start justify-start relative rounded-2xl shrink-0 w-full overflow-hidden p-0">
      <div className="relative h-[min(240px,_30vh)] w-full">
        <div
          className="absolute bg-center bg-cover bg-no-repeat inset-0"
          style={{ backgroundImage: `url('${image}')` }}
        />
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute bottom-4 left-4 text-white">
          <div className="text-[min(72px,_12vw)] font-paperlogy font-extrabold opacity-40 mb-2 leading-[0.8] font-bold">
            {number}
          </div>
          <h4 className="text-[min(20px,_4vw)] font-paperlogy font-bold leading-normal tracking-[-0.4px]">
            {title}
          </h4>
        </div>
      </div>
      <div className="py-6">
        <p className="font-paperlogy font-normal text-[15px] text-[#666666] leading-normal tracking-[-0.8px] whitespace-pre-line px-6">
          {description}
        </p>
      </div>
    </div>
  );
}

// Business Advantage Cards Grid Component
export function BusinessAdvantageCards() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
      {businessAdvantages.map((advantage, index) => (
        <BusinessAdvantageCard
          key={index}
          number={advantage.number}
          title={advantage.title}
          description={advantage.description}
          image={advantage.image}
        />
      ))}
    </div>
  );
}